<template>
  <div class="page">
    <main-menu-bar/>
    <div class="page-inner">
      <screen-control-panel v-if="hasAccess"/>
      <access-denied-error v-else/>
    </div>
  </div>
</template>

<script>
import ScreenControlPanel from '../screen/ScreenControlPanel.vue'
import MainMenuBar from '../nav/MainMenuBar.vue'
import AccessDeniedError from '../errors/AccessDeniedError.vue'
import Role from '../../enums/role'
export default {
  name: 'ManageScreenPage',
  components: {
    ScreenControlPanel,
    MainMenuBar,
    AccessDeniedError
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // console.log('route enter')
      // console.log(vm.$store.getters['auth/user'])
    })
  },
  computed: {
    hasAccess () {
      if (!this.$store.getters['auth/authenticated']) {
        return false
      }
      return this.$store.getters['auth/user'].hasRole(
        [
          Role.OPERATOR,
          Role.ADMIN
        ]
      )
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/ManageScreenPage.vue